import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  InputGroupText,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DataTable from "react-data-table-component";
import { Triangle } from "react-loader-spinner";
import { Link } from "react-router-dom";
import WaiterForm from "../component/WaiterForm";
import WaiterService from "../../../services/OrderingServices/WaiterService";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import toast from "react-hot-toast";
import DeleteModal from "../../../Components/Common/DeleteModal";
import useIsMobile from "../../../Components/Common/MobileScreen";
import useIsSmallScreen from "../../Payment Type/Component/small screen/SmallScreen";
import useTableSearch from "../../../hooks/useTableSearch";
import TableSearch from "../../../Components/Common/TableSearch";
import ResponsiveDataManagement from "../../../Components/Common/ResponsiveManagementLayout";
const Waiter = () => {
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [waiterList, setWaiterList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  // const toggleModal = (row) => {
  //   setSelectedItem(row);
  //   setIsModalOpen(!isModalOpen);
  // };
  const [deleteModal, setDeleteModal] = useState(false);

  const isSmallScreen = useIsSmallScreen();

  const toggleModal = (item = null) => {
    if (!isModalOpen && item) {
      setSelectedItem(item); // for editing
    } else {
      setSelectedItem(null); // reset to create mode
    }
    setIsModalOpen(!isModalOpen);
  };

  const customStyles = {
    headCells: { style: { fontSize: "0.92rem", fontWeight: 610 } },
    rows: { style: { fontSize: "0.9rem" } },
  };
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,
      sortable: false,
      width: "75px",
    },

    {
      name: `Name`,
      selector: (row) => `${row.firstName} ${row.lastName}`,
      sortable: true,
    },
    {
      name: `Email`,
      selector: (row) => row.email,
      cell: (row) => <span title={row.email}>{row.email}</span>,
      sortable: true,
      width: "25vw",
    },
    {
      name: `Phone no`,
      selector: (row) => row.phoneNumber,
      sortable: true,
    },
    {
      name: `Role`,
      selector: (row) => row.roles[0],
      sortable: true,
    },
    // {
    //   name: "Action",
    //   selector: (row) => (
    //     <div>
    //       <Button
    //         color="btn btn-soft-warning"
    //         className="btn-sm ms-1"
    //         onClick={() => toggleModal(row)} // ✅ Correct
    //       >
    //         <i className="ri-edit-line" />
    //       </Button>
    //       <Button
    //         className="btn btn-soft-danger btn-sm ms-1"
    //         color="danger"
    //         onClick={() => handleDeleteClick(row.id)}
    //       >
    //         <i className="ri-delete-bin-5-line" />
    //       </Button>
    //     </div>
    //   ),
    //   center: true,
    // },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await WaiterService.getList();

      setWaiterList(response);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchData();
  }, []);

  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const { searchTerm, setSearchTerm, filteredData } = useTableSearch(
    waiterList,
    ["firstName", "lastName", "email", "phoneNumber", "roles"]
  );

  // const filteredData = waiterList.filter((pkg) => {
  //   // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);
  //   const searchContext = `${pkg?.firstName || ""} ${pkg?.lastName || ""} ${
  //     pkg?.email || ""
  //   } ${pkg?.phoneNumber || ""}`.toLowerCase();
  //   const matchesFilter = searchContext.includes(filterText.toLowerCase());
  //   return matchesFilter;
  // });

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (selectedItem) {
      try {
        const response = await WaiterService.delete(selectedItem);
        setWaiterList((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedItem)
        );
        toast.success(response);
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedItem(null);
      }
    }
  };
  return (
    <>
      {" "}
      <ResponsiveDataManagement
        title="Staffs"
        pageTitle="User Management"
        mobileCardTitle="Staffs List"
        data={filteredData}
        columns={columns}
        stats={[]} // optional
        searchKeys={["firstName", "lastName", "email", "phoneNumber", "roles"]}
        loading={loading}
        onAdd={() => toggleModal(null)}
        onEdit={(row) => toggleModal(row)}
        onDelete={(id) => handleDeleteClick(id)}
        emptyStateMessage="No Staffs Available"
        // emptyStateIcon="ri-team-line"
        customStyles={customStyles}
        mobileCardRenderer={(item) => (
          <Card className="shadow-sm rounded-3 border-0 border-start border-4 border-success">
            <CardBody className="p-3">
              <Row className="align-items-center">
                <Col xs={9}>
                  <h6 className="fw-bold mb-1 text-primary">
                    {item.firstName} {item.lastName}
                  </h6>
                  <p
                    className="text-muted mb-1"
                    style={{ fontSize: "0.85rem" }}
                  >
                    <i className="bx bx-envelope me-1"></i> {item.email || "-"}
                  </p>
                  <p
                    className="text-muted mb-1"
                    style={{ fontSize: "0.85rem" }}
                  >
                    <i className="bx bx-phone me-1"></i>{" "}
                    {item.phoneNumber || "-"}
                  </p>
                  <p className="mb-0" style={{ fontSize: "0.85rem" }}>
                    <strong>Role:</strong> {item.roles[0] || "None"}
                  </p>
                </Col>

                <Col xs={3} className="text-end">
                  <Dropdown
                    isOpen={item.dropdownOpen || false}
                    toggle={() => {
                      setWaiterList((prev) =>
                        prev.map((w) =>
                          w.id === item.id
                            ? { ...w, dropdownOpen: !w.dropdownOpen }
                            : { ...w, dropdownOpen: false }
                        )
                      );
                    }}
                  >
                    <DropdownToggle
                      color="light"
                      className="btn-sm rounded-circle shadow-sm"
                    >
                      <i className="ri-more-2-fill"></i>
                    </DropdownToggle>

                    <DropdownMenu end>
                      <DropdownItem onClick={() => toggleModal(item)}>
                        <i className="ri-edit-line text-warning me-2"></i> Edit
                      </DropdownItem>
                      <DropdownItem onClick={() => handleDeleteClick(item.id)}>
                        <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                        Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      />
      <WaiterForm
        isOpen={isModalOpen}
        toggle={toggleModal}
        selectedItem={selectedItem}
        fetchData={fetchData}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedItem}
      />
    </>

    // <Container fluid>
    //   <div className="page-content">
    //     <BreadCrumb title="Staffs" pageTitle="User Management" />

    //     <div
    //       className="p-3 p-lg-4 mt-1"
    //       style={{
    //         background: "#fff",
    //         borderRadius: "0.5rem",
    //         boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
    //         border: "1px solid #eee",
    //       }}
    //     >
    //       {/* Filter Button */}
    //       <Row className="justify-content-between align-content-center align-items-center ">
    //         <Col md={6} className="align-items-center">
    //           <h5 className="mb-1 fw-bold text-dark ">Staffs List</h5>
    //         </Col>
    //         <Col md={6} className="mb-3">
    //           <div className="d-flex justify-content-end align-content-center align-items-center gap-3">
    //             <div className="d-flex align-items-center justify-content-end">
    //               {/* <InputGroup>
    //                 <Input
    //                   placeholder="Search by name, email and phone number"
    //                   value={filterText}
    //                   onChange={handleFilterChange}
    //                 />
    //                 <InputGroupText style={{ cursor: "pointer" }}>
    //                   <i className="bx bx-search"></i>
    //                 </InputGroupText>
    //               </InputGroup> */}

    //               <TableSearch
    //                 value={searchTerm}
    //                 onChange={setSearchTerm}
    //                 placeholder="Search by all.."
    //               />
    //             </div>
    //             <Button
    //               color="success"
    //               onClick={() => toggleModal(null)}
    //               className="d-flex align-items-center gap-2"
    //               style={{ borderRadius: "8px" }}
    //             >
    //               <i className="bx bx-plus"></i> Add
    //             </Button>
    //           </div>
    //         </Col>
    //         {/* </div> */}
    //       </Row>

    //       {/* <Row>
    //       <Col md={6} xs={12} className="mb-2 position-relative">
    //         <i
    //           className="bx bx-search fs-5 text-muted position-absolute"
    //           style={{
    //             paddingLeft: "1rem",
    //             top: "50%",
    //             transform: "translateY(-45%)",
    //             pointerEvents: "none",
    //           }}
    //         ></i>
    //         <Input
    //           placeholder="Search by name, email and phone number"
    //           value={filterText}
    //           onChange={handleFilterChange}
    //           style={{
    //             paddingLeft: "3rem",
    //             borderRadius: "8px",
    //             height: "40px",
    //             border: "1px solid #ddd",
    //           }}
    //         />
    //       </Col>
    //     </Row> */}
    //       {isSmallScreen ? (
    //         loading ? (
    //           <div className="d-flex justify-content-center my-3">
    //             <Triangle
    //               visible={true}
    //               height="80"
    //               width="80"
    //               color="#5B71B9"
    //             />
    //           </div>
    //         ) : (
    //           <>
    //             {filteredData?.map((item, index) => (
    //               <Card
    //                 key={item.id || index}
    //                 className="mt-2  d-md-none d-lg-none"
    //               >
    //                 <CardBody>
    //                   <Row>
    //                     <Col xs={10}>
    //                       <h6 className="mb-2">{`${item.firstName} ${item.lastName}`}</h6>
    //                       <h6 className="mb-2 text-muted">{item?.email}</h6>
    //                       <h6 className="mb-2">{item?.phoneNumber}</h6>
    //                       <h6 className="">
    //                         <strong>Role:</strong> {item?.roles[0] || "none"}
    //                       </h6>
    //                     </Col>
    //                     <Col xs={2}>
    //                       <div>
    //                         <Dropdown
    //                           isOpen={item.dropdownOpen || false}
    //                           toggle={() => {
    //                             setWaiterList((prev) =>
    //                               prev.map(
    //                                 (customer) =>
    //                                   customer.id === item.id
    //                                     ? {
    //                                         ...customer,
    //                                         dropdownOpen:
    //                                           !customer.dropdownOpen,
    //                                       }
    //                                     : { ...customer, dropdownOpen: false } // close all others
    //                               )
    //                             );
    //                           }}
    //                           direction="down"
    //                         >
    //                           <DropdownToggle
    //                             color="primary"
    //                             outline
    //                             className="btn-sm  shadow-sm rounded-circle"
    //                           >
    //                             <i className="ri-more-2-fill"></i>
    //                           </DropdownToggle>
    //                           <DropdownMenu end>
    //                             <DropdownItem
    //                               onClick={() => toggleModal(item)} // ✅ Correct
    //                             >
    //                               <i className="ri-edit-line text-warning me-2"></i>{" "}
    //                               Edit
    //                             </DropdownItem>
    //                             <DropdownItem
    //                               onClick={() => handleDeleteClick(item?.id)}
    //                             >
    //                               <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
    //                               Delete
    //                             </DropdownItem>
    //                           </DropdownMenu>
    //                         </Dropdown>
    //                       </div>
    //                     </Col>
    //                   </Row>
    //                 </CardBody>
    //               </Card>
    //             ))}
    //           </>
    //         )
    //       ) : (
    //         <CustomDataTable
    //           responsive
    //           striped
    //           pagination
    //           fixedHeader
    //           persistTableHead
    //           progressPending={loading}
    //           customStyles={customStyles}
    //           progressComponent={
    //             <div className="my-3">
    //               <Triangle
    //                 visible={true}
    //                 height="80"
    //                 width="80"
    //                 color="#5B71B9"
    //                 ariaLabel="triangle-loading"
    //               />
    //               <h5 className="mt-1">Loading...</h5>
    //             </div>
    //           }
    //           columns={columns}
    //           data={filteredData}
    //           noDataComponent={
    //             <div className="text-center my-5 w-100">
    //               <i className="ri-emotion-unhappy-line display-4 text-secondary" />
    //               <h5 className="fw-semibold text-secondary">
    //                 No data Available
    //               </h5>
    //               <p className="text-muted mb-0">No recipes found.</p>
    //             </div>
    //           }
    //         />
    //       )}
    //     </div>

    //     <WaiterForm
    //       isOpen={isModalOpen}
    //       toggle={toggleModal}
    //       selectedItem={selectedItem}
    //       fetchData={fetchData}
    //     />
    //     <DeleteModal
    //       show={deleteModal}
    //       onDeleteClick={handleDelete}
    //       onCloseClick={toggleDeleteModal}
    //       selectedItem={selectedItem} // Pass the selected item
    //     />
    //   </div>
    // </Container>
  );
};

export default Waiter;
